(function($)
{
    function WristbandBuilder(item, options)
    {
        // Framework set
        this.options = $.extend({},options);
        this.$item = $(item);

        // Elements
		this.$outerPreview;
		this.$previewImage;
		this.$textLine1;
		this.$textOuter1;
		this.$textLine2;
		this.$textOuter2;
		this.$textLines;
		this.$textOuters;
		this.$iconLeft;
		this.$iconRight;
		this.$warnings;
		this.$typeSelect;
	
		// Fields
		this.$field_colour;
		this.$field_size;
		this.$field_age;
		this.$field_line1;
		this.$field_line2;
		this.$field_font1;
		this.$field_font2;
		this.$field_logoLeft;
		this.$field_logoRight;
		
		this.$fields;
		
		this.size = 25;
		this.iconLeftSet = false;
		this.iconRightSet = false;
		
		// Colours
		this.colours = [{"name":"Neon Yellow","code":"f6f679"},{"name":"Neon Orange","code":"fdb85e"},{"name":"Dark Green","code":"007302"},{"name":"Neon Green","code":"5adc5a"},{"name":"Aqua","code":"5ad9dc"},{"name":"Gold","code":"c4b249"},{"name":"Silver","code":"adadad"},{"name":"Yellow","code":"ebea74"},{"name":"Neon Pink","code":"fb859b"},{"name":"Purple","code":"893efb"},{"name":"Red","code":"f95a57"},{"name":"Sky Blue","code":"88c7f5"},{"name":"White","code":"FFFFFF"}];
      
	    // Variables
		this.userSelection = {};
      
		// Start the application
        this.init();
    }

    WristbandBuilder.prototype = {
        init: function() {
		
			//var showBuilder = this.getParameterByName('showBuilder');
			var showBuilder = 1;
			
			if (showBuilder == 1 && $('#WBuilder').size() > 0) {
				
				var $t = this;
				
				this.userSelection = {};
				
				$('#WBuilder').show();
				
				// Preview elements
				this.$outerPreview = $('#WristbandPreview');
				this.$previewImage = $('#PreviewImage');
				this.$textLine1 = $('#TextLine1');
				this.$textLine2 = $('#TextLine2');
				this.$textOuter1 = $('#TextOuter1');
				this.$textOuter2 = $('#TextOuter2');
				this.$textOuters = $('#TextOuter1, #TextOuter2');
				this.$textLines = $('#TextLine1, #TextLine2');
				this.$iconLeft = $('#IconLeft');
				this.$iconRight = $('#IconRight');
				this.$warnings = $('#WBuilder .Warning');
				this.$typeSelect = $('#WBuilder .TypeSelect');
				
				// Fields
				this.$field_colour = $('#product-select-option-0');
				this.$field_size = $('#product-select-option-1');
				this.$field_age = $('#138741');
				this.$field_line1 = $('#shappify_option_137451');
				this.$field_line2 = $('#shappify_option_180029');
				this.$field_font1 = $('#137452');
				this.$field_font2 = $('#180030');
				this.$field_logoLeft = $('#138740');
				this.$field_logoRight = $('#180031');
				
				this.$fields = $("#product-select-option-0, #product-select-option-1, #138741, #shappify_option_137451, #shappify_option_180029, #137452, #180030, #138740, #180031");
	
				this.loadSettings();
	
				//this.updateType();
				
				// Event handlers on field changes
				this.$fields.change(
					function()
					{
						$t.updateFields();
						$t.buildCookie();
					}
				);
				
				this.$field_colour.change(
					  function(e)
					  {
						  var color = $t.getColor($(this).val());
						  if (color) {
							  $t.$outerPreview.css('background-color','#' + color.code);
						  }
		  
					  }
		  
				  ).change();

				// Logo Select
				  $('#180031, #138740').change(
					  function()
					  {
						  
						  // bulk update logos
						  var imLeft = $t.$field_logoLeft.val();
						  if (imLeft.length > 0) {
							 
							  var imLeftUrl = $t.getImageUrl(imLeft);
							  //$t.$iconLeft.html('<img src="i/' + imLeft + '">');
							  $t.$iconLeft.html('<img src="' + imLeftUrl + '">');
							  $t.$iconLeft.css('display','inline-block');
							  $t.iconLeftSet = true;
						  } else {
							  $t.$iconLeft.hide();
  							  $t.iconLeftSet = false;
						  }
		  
						  var imRight = $t.$field_logoRight.val();
						  if (imRight.length > 0) {
							   var imRightUrl = $t.getImageUrl(imRight);
							  $t.$iconRight.html('<img src="' + imRightUrl + '">');
							  $t.$iconRight.css('display','inline-block');
  							  $t.iconRightSet = true;
						  } else {
							  $t.$iconRight.hide();
   							  $t.iconRightSet = false;
						  }
		  
						  $t.updatePositions();
					  }
				  ).change();
				  
  				// Text Entry
		  		$('#shappify_option_137451, #shappify_option_180029').keyup(
					  function(e)
					  {
						  var id = $(this).attr('id');
						  var str = $(this).val();
		  
						  var num;
						  switch(id) {
							  case 'shappify_option_137451':
								  num = 1;
								  break;
							  case 'shappify_option_180029':
								  num = 2;
								  break;
						  }
		  
						  $t['$textLine' + num].html(str);
						  if (str.length > 0) {
							  $t['$textOuter' + num].show();
						  } else {
							  $t['$textOuter' + num].hide();
						  }
		  
						  $t.updatePositions();
					  }
				  ).keyup();
				  
				  this.$field_size.change(
				  	function()
					{
						var v = $(this).val();
						if (v == '19mm') {
							$t.size = 19;
							$t.$outerPreview.removeClass('Size25');
							$t.$outerPreview.addClass('Size19');
						}
						if (v == '25mm') {
							$t.size = 25;
							$t.$outerPreview.removeClass('Size19');
							$t.$outerPreview.addClass('Size25');
						}
						$t.updatePositions();	
					}
				  ).change();
				  
				  this.$field_age.change(
				  	function ()
					{
						var v = $(this).val();
						if (v == 'Child') {
							$t.$outerPreview.addClass('Child');	
						} else {
							$t.$outerPreview.removeClass('Child');	
						}
					}
				  ).change();
				  
  				// Font
				  $('#137452, #180030').change(
					  function()
					  {
						  // Bulk update fonts
						  var font1 = $('#137452').val();
						  var font2 = $('#180030').val();
		  
						  $t.$textLine1.css('font-family', font1);
						  $t.$textLine2.css('font-family', font2);
		  
						  $t.updatePositions();
		  
					  }
				  ).change();
			
			}
			
        },
        onResize: function()
        {
			
        },
		updateType: function()
		{
			var type = this.$typeSelect.find('.Active').data('type');
			if (type == 'Plain') {
				$('#PricesCustom').hide();
				$('#PricesPlain').show();
				
				$('#AgeBox, #TextFields, #LogoFields').hide();
			} else {
				$('#PricesCustom').show();
				$('#PricesPlain').hide();
				$('#AgeBox, #TextFields, #LogoFields').show();
			}
		},
		updateFields: function()
		{
			
			if (this.$field_size.val() != '25mm') {
				$('.Only25').hide();
				$('.Only19').show();
			} else {
				$('.Only25').show();
				$('.Only19').hide();
			}
		},
		updatePositions: function()
		{
			// Calculate available space
			var w = this.$previewImage.width();
			var h = this.$previewImage.height();
			var left = 0;
			var right = 0;
			
			if (this.size != 25) {
				this.$textOuter2.hide(); 
				this.$iconLeft.hide();
				this.$iconRight.hide();
			} else {
				if (this.$textLine2.html().length > 0) {
					this.$textOuter2.show();
				}
				
				if (this.iconLeftSet) {
					this.$iconLeft.css('display','inline-block');
				}
				if (this.iconRightSet) {
					this.$iconRight.css('display','inline-block');
				}

			}
						
			if (this.$iconLeft.is(':visible')) {
				left = this.$iconLeft.outerWidth();
				w -= left;
			}
			if (this.$iconRight.is(':visible')) {
				right = this.$iconRight.outerWidth();
				w -= right;
			}
	
			var lineHeight = h;
			var twoLines = false;
			if (this.$textOuter1.is(':visible')&&this.$textOuter2.is(':visible')) {
				lineHeight = lineHeight/2;
				twoLines = true;
			}
	
			this.$textOuters.css({
				left: left + 'px',
				right: right + 'px',
//				'line-height': lineHeight + 'px'
			});
	
			if (twoLines) {
				this.$textOuter2.css('top', '50%');
				this.$outerPreview.addClass('TwoLines');
			} else {
				this.$textOuters.css('top',0);
				this.$outerPreview.removeClass('TwoLines');
			}
	
			// Check boundaries
			var showWarnings = false;
			if (this.$textLine1.width() > this.$textOuter1.width()) {
				showWarnings = true;
				this.$warnings.find('.TooMuchLine1').show();
			} else {
				this.$warnings.find('.TooMuchLine1').hide();
				/*
				$('#line1Label').removeClass('Error');
				this.$field_line1.removeClass('Error');
				*/
			}
			if (this.$textLine2.width() > this.$textOuter2.width()) {
				showWarnings = true;
				this.$warnings.find('.TooMuchLine2').show();
				/*
				$('#line2Label').addClass('Error');
				this.$field_line2.addClass('Error');
				*/
			} else {
				this.$warnings.find('.TooMuchLine2').hide();
				/*
				$('#line2Label').removeClass('Error');
				this.$field_line2.removeClass('Error');
				*/
			}
			
			if (showWarnings) {
				this.$warnings.fadeIn();	
			} else {
				this.$warnings.fadeOut();	
			}
	
		},
		getImageUrl: function(name){
			return $('#Images').find('.IconPrint-' + name).attr('src');
		},
		getColor: function(name)
		{
			for (var i = 0;i < this.colours.length;i++) {
				if (this.colours[i].name == name) {
					return this.colours[i];
				}
			}
			return false;
		},
		buildCookie: function()
		{
			
			// Wrap all fields into a serialised cookie
			this.userSelection['colour'] = this.$field_colour.val();
			this.userSelection['size'] = this.$field_size.val();
			this.userSelection['age'] = this.$field_age.val();
			this.userSelection['line1'] = this.$field_line1.val();
			this.userSelection['line2'] = this.$field_line2.val();
			this.userSelection['font1'] = this.$field_font1.val();
			this.userSelection['font2'] = this.$field_font2.val();
			this.userSelection['logoLeft'] = this.$field_logoLeft.val();
			this.userSelection['logoRight'] = this.$field_logoRight.val();
			var data = JSON.stringify(this.userSelection);
			this.setCookie('buildOptions', data);
			
		},
		loadSettings: function()
		{
			var settings = this.getCookie('buildOptions');
			if (settings) {
				this.settings = JSON.parse(settings);

				// Colour
				this.$field_colour.val(this.settings['colour']);
			
				// Size
				this.$field_size.val(this.settings['size']);
			
				// Line 1
				this.$field_line1.val(this.settings['line1']);
			
				// Line 2 
				this.$field_line2.val(this.settings['line2']);
			
				// Font 1
				this.$field_font1.val(this.settings['font1']);
			
				// Font 2
				this.$field_font2.val(this.settings['font2']);
			
				// Logo Left
				this.$field_logoLeft.val(this.settings['logoLeft']);
			
				// Logo Right
				this.$field_logoRight.val(this.settings['logoRight']);		
			
				// Adult/Child
				this.$field_age.val(this.settings['age']);

			}
		},
		getParameterByName: function(name) {
		    name = name.replace(/[\[]/, "\\[").replace(/[\]]/, "\\]");
		    var regex = new RegExp("[\\?&]" + name + "=([^&#]*)"),
		        results = regex.exec(location.search);
		    return results === null ? "" : decodeURIComponent(results[1].replace(/\+/g, " "));
		},
		setCookie: function(cname, cvalue, exdays)
		{
		    var d = new Date();
		    d.setTime(d.getTime() + (exdays*24*60*60*1000));
		    var expires = "expires="+d.toUTCString();
		    document.cookie = cname + "=" + cvalue + "; " + expires + ";path=/";
		},
		getCookie: function(cname)
		{
		    var name = cname + "=";
		    var ca = document.cookie.split(';');
		    for(var i=0; i<ca.length; i++) {
		        var c = ca[i];
		        while (c.charAt(0)==' ') c = c.substring(1);
		        if (c.indexOf(name) == 0) return c.substring(name.length,c.length);
		    }
		    return "";
		}

    };

    // Setup
    $.fn.wristbandBuilder = function(opt) {
        // slice arguments to leave only arguments after function name
        var args = Array.prototype.slice.call(arguments, 1);
        return this.each(function() {
            var item = $(this), instance = item.data('WristbandBuilder');
            if(!instance) {
                // create plugin instance and save it in data
                item.data('WristbandBuilder', new WristbandBuilder(this, opt));
            } else {
                // if instance already created call method
                if(typeof opt === 'string') {
                    instance[opt].apply(instance, args);
                }
            }
        });
    }
})(jQuery);

$(document).ready(function() {
    $(window).load(function()
    {
        $('body').wristbandBuilder();
    });
});